import {ColumnGrid, GridRow} from "./ColumnGrid";
import useAxiosRequest from "../hooks/useAxiosRequest";

import '../styles/MapTemplateList.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";

import config from '../config.json';
import useCheckPanelAdministrator from "../hooks/useCheckPanelAdministrator";

const MapTemplateInfo = ({ template }) => {
    return (
        <div className="MapTemplateInfo" onClick={() => window.location = '/maps?editTemplate=' + template._id}>
            <ColumnGrid columns="1fr auto auto">
                <GridRow>
                    <span>{template.name}</span>
                    <span>{new Date(template.lastModified).toLocaleDateString('en-US', { hour: 'numeric', minute: 'numeric' })}</span>
                    <span style={{ marginLeft: '20px' }}><FontAwesomeIcon icon={faTrash}/></span>
                </GridRow>
            </ColumnGrid>
        </div>
    );
}

const InternalTemplateList = () => {
    let {isLoading, data: templates, error} = useAxiosRequest({
        url: `${config.backendUrl}/maps/templates`,
        withCredentials: true,
        method: "get"
    });

    if (isLoading || error) return;

    return (
        <div className="MapTemplateList" style={{ display: templates.length ? '' : 'none' }}>
            <span className="title">Map Templates</span>
            {templates.map(template => <MapTemplateInfo key={template._id} template={template}/>)}
        </div>
    );
}

const MapTemplateList = () => {
    const { isLoading, panelAdministrator } = useCheckPanelAdministrator();

    if (isLoading || !panelAdministrator) return;

    return <InternalTemplateList/>;
}

export default MapTemplateList;
